import Vue from 'vue'
import CacheManageBox from './main.vue'
import CacheDB from '../cache-db'

const CacheManageConstructor = Vue.extend(CacheManageBox)

let instance

const initInstance = () => {
  instance = new CacheManageConstructor({
    el: document.createElement('div'),
  })
  document.body.appendChild(instance.$el)
}

const CacheManage = function (key, callback) {
  CacheManage.readCache(key, callback)
}

CacheManage.readCache = function (key, callback) {
  if (!instance) {
    initInstance()
  }
  instance.key = key
  instance.visible = true
  instance.callback = callback
}

CacheManage.destroy = () => {
  if (instance) {
    instance.$el.remove()
    instance.$destroy()
    instance = null
  }
}

Object.assign(CacheManage, CacheDB)

export default CacheManage
export { CacheManage }



// WEBPACK FOOTER //
// ./src/views/question-review/components/CacheManage/src/main.js